import {
  CheckboxGroup,
  type CheckboxGroupOption,
} from "@/components/ui/CheckboxGroup";
import { InputColumnFilterContainer } from "./InputColumnFilterContainer";

interface CheckboxColumnFilterFieldProps {
  value: string[];
  options: CheckboxGroupOption[];
  onChange: (value: string[]) => void;
}

export function CheckboxColumnFilterField({
  value,
  options,
  onChange,
}: CheckboxColumnFilterFieldProps) {
  return (
    <InputColumnFilterContainer className="w-[230px]">
      <CheckboxGroup value={value} options={options} onChange={onChange} />
    </InputColumnFilterContainer>
  );
}
